import { Values, FormFields } from '../types'
import { FormField } from '@generated'
import { useFormikContext } from 'formik'
import { FC } from 'react'
import { AccountCreationField } from './AccountCreationField'
import { AddressFields } from './AddressFields'
import { AttendanceFields } from './AttendanceFields'
import { BasicFields } from './BasicFields'
import { EventSpecificFields } from './EventSpecificFields'
import { MessageField } from './MessageField'
import { PhoneField } from './PhoneField'
import { PrivacyPolicyField } from './PrivacyPolicyField'
import { isFieldEnabled, getFieldValue } from '../utils'

type FieldsProps = {
  formId: string
  fields: FormFields
  showAttendance?: boolean
}

export const Fields: FC<FieldsProps> = ({ formId, fields, showAttendance = true }) => {
  const { values } = useFormikContext<Values>()

  const willAttend = showAttendance ? values.attendance === true : true

  const actualSelectableDates = getFieldValue(fields, FormField.Date) ?? []
  const actualSelectableTimes = getFieldValue(fields, FormField.Time) ?? []
  const actualSelectableLocations = getFieldValue(fields, FormField.Location) ?? []
  const actualMaxPersons = getFieldValue(fields, FormField.NumberOfPersons) ?? 50

  const getSpecificField = (fieldType: FormField) => {
    return fields.find((f) => f.type === fieldType)
  }

  const isFieldEnabledInStructure = (fieldType: FormField): boolean => {
    return isFieldEnabled(fields, fieldType)
  }

  return (
    <>
      {showAttendance && <AttendanceFields />}
      <BasicFields />

      {willAttend ? (
        <>
          {isFieldEnabledInStructure(FormField.HomeAddress) && (
            <AddressFields field={getSpecificField(FormField.HomeAddress)!} />
          )}
          {isFieldEnabledInStructure(FormField.PhoneNumber) && (
            <PhoneField field={getSpecificField(FormField.PhoneNumber)!} />
          )}
          <EventSpecificFields
            fields={fields}
            selectableDates={actualSelectableDates}
            selectableTimes={actualSelectableTimes}
            maxPersons={actualMaxPersons}
            selectableLocations={actualSelectableLocations}
          />
          {isFieldEnabledInStructure(FormField.Message) && (
            <MessageField field={getSpecificField(FormField.Message)} />
          )}
          {isFieldEnabledInStructure(FormField.CreateAccount) && <AccountCreationField />}
        </>
      ) : (
        <MessageField field={getSpecificField(FormField.Message)} />
      )}
      <PrivacyPolicyField formId={formId} />
    </>
  )
}
